<div class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Regroupement de comptes</div>
</div>

@if (status == 'finished') {
    <div class="col-12">
        <div class="header-description">Pour avoir toutes vos lignes sur ce compte, indiquez le nom et le n° de client
            du compte à rattacher à celui-ci. <strong>Attention, cette action est irréversible.</strong> Vous n'aurez
            alors plus qu'un seul Espace client, une seule facture et un seul prélèvement pour tous vos forfaits.
        </div>
        <div class="w-100">
            <form [formGroup]="customerForm" (submit)="save()">
                <div class="form-group">
                    <span class="bold-label-text float-left">Nom du titulaire * :</span>
                    <input type="text" class="form-control" placeholder="Nom" formControlName="lastName" required>
                    @if (customerFormSubmitted && customerForm.controls.lastName.errors) {
                        <small class="form-text error-message">Ce champ est invalide.</small>
                    }
                </div>
                <div class="form-group">
                    <span class="bold-label-text float-left">N° de client * :</span>
                    <input type="text" class="form-control" placeholder="N° Client" formControlName="id" required>
                    @if (customerFormSubmitted && customerForm.controls.id.errors) {
                        <small class="form-text error-message">Ce champ est invalide.</small>
                    }
                </div>
                <div class="text-center w-100 cta_container">
                    <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
                    <button type="submit" class="cta_btn level_2 column">Valider<span></span></button>
                </div>
            </form>
        </div>
    </div>
}

@if (status == 'wait_form' && message.data.src_account) {
    <div class="col-12">
        Je souhaite rattacher mon compte client {{ customer.firstName }}  {{ customer.lastName }} au
        compte {{ message.data.src_account_cus_name }}.
        <br>
        <strong>Attention, cette action est irréversible.</strong> Vous n'aurez alors plus qu'un seul Espace client, une
        seule facture et un seul prélèvement pour toutes vos lignes.
        <div class="w-100 mt-3 cta_container text-center">
            <button type="button" class="cta_cancel column" (click)="attachAccount(false)">Annuler<span></span></button>
            <button type="submit" class="cta_btn level_2 column" (click)="attachAccount(true)">Valider<span></span>
            </button>
        </div>
    </div>
}
